// GET ORDER BY ID
import axios from '../axios-config';
import { getOrderByID } from '../success';
const getAllUserOrders = async ({
  mage,
  customer_id,
  pageSize = '10',
  page = '1',
  date_filter,
}) => {
  const url = `/customer/customer-orders/${customer_id}`;

  // let url = `/customer/customer-orders/${customer_id}?searchCriteria[sortOrders][0][field]=created_at&searchCriteria[sortOrders][0][direction]=DESC&searchCriteria[page_size]=${pageSize}&searchCriteria[current_page]=${page}`;
  // if (dateFilter) {
  //   url += `&searchCriteria[filter_groups][1][filters][0][condition_type]=gt&searchCriteria[filter_groups][1][filters][0][field]=created_at&searchCriteria[filter_groups][1][filters][0][value]=${dateFilter}`;
  // }

  let config = {
    method: 'GET',
    url,
    headers: {
      mage: 'Bearer ' + mage,
    },
    params: {
      page,
      pageSize,
      ...(date_filter ? { date_filter } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const returnProducts = async ({ mage, orderId, items }) => {
  let config = {
    method: 'POST',
    url: `/customer/returnRequest/${orderId}`,
    headers: {
      mage: 'Bearer ' + mage,
    },
    data: JSON.stringify({ order_item_ids: items }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const reviewProduct = async ({ mage, user, rate, desc, product_id }) => {
  const data = JSON.stringify({
    review: {
      title: 'Review Title',
      detail: desc ? desc : 'This is review details',
      nickname: `${user?.firstname} ${user?.lastname}`,
      ratings: [
        // {
        //   rating_name: 'Rating',
        //   value: rate,
        // },
        {
          rating_name: 'quality',
          value: rate,
        },
      ],
      review_entity: 'product',
      review_status: 0,
      entity_pk_value: product_id,
    },
  });
  let config = {
    method: 'POST',
    url: `/product/reviews/add`,
    headers: {
      mage: `Bearer ${mage}`,
    },
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getOrderInvoice = async ({ customerId, orderId, mage }) => {
  let config = {
    method: 'get',
    url: `/pdfpro/printOrder/${orderId}?customer_id=${customerId}&orderId=${orderId}`,
    responseType: 'blob',
    headers: {
      mage: 'Bearer ' + mage,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getOrderTrackingDetails = async (handshake, order_number, user_email) => {
  const body = {
    increment_id: order_number,
    email: user_email,
  };
  let config = {
    method: 'POST',
    url: `/customer/order-tracking-details`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data: JSON.stringify(body),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const reOrder = async ({ mage, id, customer_id }) => {
  let config = {
    method: 'post',
    url: '/mstore/reorder/me',
    headers: {
      mage: 'Bearer ' + mage,
    },
    data: JSON.stringify({ id, customer_id }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const cancelOrder = async ({
  order_id,
  email,
  phone_number,
  reason,
  customer_id,
}) => {
  let config = {
    method: 'post',
    url: '/mstore/me/order/cancel',

    data: JSON.stringify({
      order_id,
      email,
      phone_number,
      reason,
      customer_id,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getAllUserOrders,
  getOrderByID,
  getOrderTrackingDetails,
  returnProducts,
  reviewProduct,
  getOrderInvoice,
  reOrder,
  cancelOrder,
};
